<template>
  <div>
    <loading-screen v-if="isSubmitLoading" :content="loadingScreenContent" />
    <div class="m-2 text-center" v-else-if="isLoading">
      <font-awesome-icon
        :icon="['fa', 'circle-notch']"
        class="fa-spin m-auto spinner fa-5x egx-partner-color"
      />
    </div>
    <div class="container" v-show="!isLoading && !isSubmitLoading">
      <div class="content-box content-box-plus">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <div
                class="title"
                :class="pageSettings.title.class"
                :style="pageSettings.title.style"
                v-safe-html="pageSettings.title.html"
              />
              <div
                class="description"
                :class="pageSettings.description.class"
                :style="pageSettings.description.style"
                v-safe-html="pageSettings.description.html"
              />
            </div>
          </div>

          <template>
            <ValidationObserver
              tag="form"
              @submit.prevent=""
              ref="prqSave"
              class="detail-section-form"
              v-show="!isLoading"
            >
              <div v-for="section in fetchedData" :key="section.id">
                <prq
                  :section="section"
                  :isRegistration="true"
                  @answerList="addToAnswerList"
                  v-if="section.question_type === 'Question'"
                  :hideQuestionLabel=true
                />
              </div>
            </ValidationObserver>

            <div class="d-md-flex justify-content-md-end grid-container">
              <button
                class="btn btn-egx"
                :class="pageSettings.button.continue.class"
                :style="pageSettings.button.continue.style"
                @click="saveResponses"
              >
                {{ pageSettings.button.continue.text }}
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Prq from '@/components/project/Prqs.vue';
import NoConfiguredPRQs from '@/components/project/NoConfiguredPRQs.vue';
import LoadingScreen from '@/components/LoadingScreen.vue';

export default {
  name: 'UserRegistrations',

  components: {
    LoadingScreen,
    NoConfiguredPRQs,
    Prq
  },

  mounted() {},

  created() {
    if (!this.$route.query.program_id){
      this.$nextTick(() => {
        this.$notify({
          group: 'notice-stay',
          type: 'error',
          text: "Program ID can't be empty.",
        });
      });

      this.$router.push('/offers-public?errorPersist=true');
    } else {
      this.fetchPRQs();
    }
  },

  data() {
    return {
      isLoading: true,
      isSubmitLoading: false,
      fetchedData: [],
      allAnswerList: {},
    };
  },

  methods: {
    fetchPRQs() {
      this.isLoading = true;
      const params = { ...this.$route.query };
      this.$store.dispatch('prq_registrations/get', params).then((response) => {
        console.log('Success!');
        this.fetchedData = response.data;

        this.fetchedData =
          this.fetchedData.sort(
            (a, b) => a.sorting_tag.localeCompare(b.sorting_tag, 'en', { numeric: true })
          );
        this.isLoading = false;
      }).catch((error) => {
        const errors = error?.error || error?.errors?.join('\n') || error;
        console.log(errors);
        this.$notify({
          group: 'notice-stay',
          type: 'error',
          text: errors,
        });
        this.$router.push('/offers-public?errorPersist=true');
      }).finally(() => {
        this.isLoading = false;
      });
    },

    addToAnswerList(groupId, answerObject) {
      this.allAnswerList[groupId] = Object.values(answerObject);
    },

    saveResponses() {
      this.$refs.prqSave.validate()
        .then((isValid) => {
          if (isValid) {
            this.isSubmitLoading = true;
            let payload = {
              responses: this.allAnswerList,
              program_id: this.programId,
            };
            this.$store.dispatch('prq_registrations/post', payload).then(() => {
              console.log('Success!');
              this.$router.push({ path: `/applications/${this.currentUser.extra_info.project_id}/edit` });
              this.$notify({
                group: 'notice-stay',
                type: 'success',
                text: 'Your responses have been saved successfully.',
              });
            }).catch((error) => {
              this.isSubmitLoading = false;
              const errors =  error?.error || error?.errors?.join('\n') || error;
              console.log(errors);
              this.$notify({
                group: 'notice-stay',
                type: 'error',
                text: errors,
              });
            });
          } else {
            console.log('Not Validated.');
            this.isLoading = false;

            this.$notify({
              group: 'notice-stay',
              type: 'error',
              text: this.fulfillSyncDetails?.messages?.validations || 'Please complete all required fields and uploads before moving forward.',
            });

            this.$nextTick(() => {
              const hasError = this.$el.querySelector('.has-error');
              if (hasError) {
                hasError.scrollIntoView({ block: 'center', behavior: 'smooth' });
              }
            });
          }
        })
    },
  },

  computed: {
    partner() {
      return this.$store.state.partners.currentPartner;
    },

    pageSettings() {
      return this.partner.settings.sections.prq_registration_page;
    },

    programId() {
      return this.$route.query.program_id;
    },

    currentUser() {
      return this.$store.state.users.currentUser;
    },

    fulfillSyncDetails() {
      return this.partner.settings.fulfill_sync_details;
    },

    loadingScreenContent() {
      return this.pageSettings?.loading_screen || {
        title: {
          text: 'Adding your account',
          class: ['egx-partner-color'],
          style: 'color: var(--egx-partner-color)',
        },
        description: {
          text: 'Please wait while we update your account details.'
        },
        spinner:{
          class: ['egx-partner-color']
        },
        cta: {
          text: 'If this page doesn\'t refresh, please try again.',
          class: ['egx-partner-color'],
          path_name: 'home'
        }
      }
    },

  },
};
</script>

<style scoped lang="scss">
</style>

